import React from "react";
import { useTranslation } from "react-i18next";
import { Video } from "lucide-react";

/** Hero shown in the detail pane before a transcript is selected. */
export const EmptyTranscriptState: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div className="flex h-full flex-col items-center justify-center gap-3 bg-muted/30 p-8 text-center animate-fade-in">
			<div className="flex h-16 w-16 items-center justify-center rounded-sm border border-border bg-card shadow-card">
				<Video className="h-7 w-7 text-muted-foreground" />
			</div>
			<h3 className="text-lg font-semibold text-foreground">
				{t("transcripts.empty.selectTitle", "Select a transcript")}
			</h3>
			<p className="max-w-xs text-sm text-muted-foreground">
				{t(
					"transcripts.empty.selectDescription",
					"Choose a meeting on the left to read the transcript, AI summary and insights."
				)}
			</p>
		</div>
	);
};
